module.exports = __webpack_public_path__ + "img/icon_dianti_01.c7d2295e.png";